module.exports = __webpack_public_path__ + "static/media/3.cfc49171.jpeg";